import { useSelector } from "react-redux";
import useFeature from "./useFeature";
import usePermission from "./usePermission";
import useSubscriptionAccess from "./useSubscriptionAccess";

// UI-only decision from the existing login/Redux snapshot; no extra network calls.
export default function useAccess() {
  const { accessType } = useSelector((state) => state.clientFunction);
  const { hasModule, hasCapability } = useFeature();
  const { can } = usePermission();
  const subscription = useSubscriptionAccess();
  const check = ({ module, capability, permission } = {}) => {
    if (!subscription.active || (module && !hasModule(module)) || (capability && !hasCapability(capability))) {
      return { allowed: false, reason: "subscription" };
    }
    if (accessType !== "CLIENT_ACCESS" && (!permission || !can(permission))) {
      return { allowed: false, reason: "permission" };
    }
    return { allowed: true, reason: null };
  };
  const message = (result, label = "This feature") => result.reason === "subscription"
    ? `${label} is not included in your current subscription. Contact the company owner to upgrade the plan.`
    : `You do not have permission to use ${label.toLowerCase()}. Contact your company administrator.`;
  return { check, message, hasModule, hasCapability, can, subscription };
}
